import { PageLayout } from '@/components/feature/PageLayout';
import { HeroHome } from './components/HeroHome';
import { ReassuranceBand } from './components/ReassuranceBand';
import { ProblemCards } from './components/ProblemCards';
import { ServicesSection } from './components/ServicesSection';
import { CTABand } from './components/CTABand';
import { CommuneFinder } from './components/CommuneFinder';
import { WhyUs } from './components/WhyUs';
import { HowItWorks } from './components/HowItWorks';
import { ZonesIntervention } from './components/ZonesIntervention';
import { FAQSection } from './components/FAQSection';

const seo = {
  title: 'Réparation & Dépannage de Volets Roulants à Charleroi et dans le Hainaut',
  description: 'Spécialiste en réparation, dépannage urgent et motorisation de volets roulants à Charleroi et dans le Hainaut. Devis gratuit, intervention rapide, garantie 10 ans. Appelez le 0800 20 410.',
  keywords: 'réparation volet roulant Charleroi, dépannage volet roulant Hainaut, motorisation volet roulant, volet roulant bloqué, réparateur volet Charleroi, volet roulant électrique, réparation volet Somfy',
};

export default function HomePage() {
  return (
    <PageLayout seo={seo} showDevisForm={true}>
      <HeroHome />
      <ReassuranceBand />
      <ProblemCards />
      <ServicesSection />
      <CTABand />
      <CommuneFinder />
      <WhyUs />
      <HowItWorks />
      <ZonesIntervention />
      <FAQSection />
    </PageLayout>
  );
}